export default __webpack_public_path__ + "static/media/3.f83299b8.png";